/* Truck Covers MN: trims the Convermax Year / Make lists.
   Years: 2008 and newer only. Makes: Ford, Chevrolet, GMC, Toyota, Ram first, then the rest.
   Convermax owns its <select>s, so we hide them and show a copy we control;
   a pick in the copy is passed straight to the Convermax select. */
(function () {
  var MIN_YEAR = 2008;
  var POPULAR = ['Ford', 'Chevrolet', 'GMC', 'Toyota', 'Ram'];
  var SELECTOR = '.cm_vehicle-widget select[aria-label="Year"], .cm_vehicle-widget select[aria-label="Make"]';
  var setValue = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  var proxies = [];

  var style = document.createElement('style');
  style.textContent = '.tcmn-ymm-hidden{display:none!important}';
  document.head.appendChild(style);

  function opt(o) {
    var n = document.createElement('option');
    n.value = o.value;
    n.textContent = o.textContent.trim();
    return n;
  }

  function fill(orig, proxy) {
    var kind = orig.getAttribute('aria-label');
    var opts = Array.prototype.slice.call(orig.options);
    var sig = kind + '|' + opts.map(function (o) { return o.value; }).join('|');
    if (proxy._sig !== sig) {
      proxy._sig = sig;
      proxy.textContent = '';
      var rest = [];
      var top = [];
      opts.forEach(function (o) {
        if (o.value === '') { proxy.appendChild(opt(o)); return; }
        if (kind === 'Year') {
          var y = parseInt(o.value, 10);
          if (!(y >= MIN_YEAR) && o.value !== orig.value) return;
          rest.push(o);
        } else if (POPULAR.indexOf(o.value) > -1) {
          top.push(o);
        } else {
          rest.push(o);
        }
      });
      if (top.length) {
        top.sort(function (a, b) { return POPULAR.indexOf(a.value) - POPULAR.indexOf(b.value); });
        var g1 = document.createElement('optgroup');
        g1.label = 'Most popular';
        top.forEach(function (o) { g1.appendChild(opt(o)); });
        proxy.appendChild(g1);
        var g2 = document.createElement('optgroup');
        g2.label = 'All other makes';
        rest.forEach(function (o) { g2.appendChild(opt(o)); });
        proxy.appendChild(g2);
      } else {
        rest.forEach(function (o) { proxy.appendChild(opt(o)); });
      }
    }
    if (proxy.value !== orig.value) proxy.value = orig.value;
    proxy.disabled = orig.disabled;
  }

  function attach(orig) {
    if (orig._tcmnProxy || orig.classList.contains('tcmn-ymm-proxy')) return;
    var proxy = document.createElement('select');
    proxy.className = orig.className + ' tcmn-ymm-proxy';
    proxy.setAttribute('aria-label', orig.getAttribute('aria-label'));
    proxy.addEventListener('change', function () {
      setValue.call(orig, proxy.value);
      orig.dispatchEvent(new Event('input', { bubbles: true }));
      orig.dispatchEvent(new Event('change', { bubbles: true }));
    });
    orig._tcmnProxy = proxy;
    orig.classList.add('tcmn-ymm-hidden');
    orig.setAttribute('tabindex', '-1');
    orig.setAttribute('aria-hidden', 'true');
    orig.insertAdjacentElement('afterend', proxy);
    fill(orig, proxy);
    proxies.push([orig, proxy]);
  }

  function scan() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) {
      if (!list[i].classList.contains('tcmn-ymm-proxy')) attach(list[i]);
    }
    proxies = proxies.filter(function (pair) {
      var orig = pair[0], proxy = pair[1];
      if (!orig.isConnected) { if (proxy.parentNode) proxy.parentNode.removeChild(proxy); return false; }
      if (!orig.classList.contains('tcmn-ymm-hidden')) orig.classList.add('tcmn-ymm-hidden');
      if (orig.nextElementSibling !== proxy) orig.insertAdjacentElement('afterend', proxy);
      fill(orig, proxy);
      return true;
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function start() {
    scan();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    document.addEventListener('change', queue, true);
    document.addEventListener('click', function () { setTimeout(queue, 50); }, true);
    setInterval(function () { if (proxies.length) scan(); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
